// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b54448b6","268":"b7c2aa9d","453":"1cf01603","455":"64a65d49","551":"9f1959a9","638":"1caf2c71","828":"f072dd97","842":"2c8714e8","940":"8c6dfe32"}[chunkId] + ".chunk.js";
};